var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Main',[_c('div',{staticClass:"center-horizontal-vertical"},[_c('v-img',{attrs:{"src":require("../assets/imaps_logo.png"),"width":"500"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }